import React, { ReactElement } from "react";
import { Column } from "../../../../components/BaseTable";
import Table from "../../../../components/Table";
import {
  DubbeleLastenOverbruggingDetails,
} from "../../../../../../.generated/rapportage/rapportagetypes";

export const DubbeleLastenOverbruggingDetailsTable = ({
  dubbeleLastenOverbruggingDetails,
}: {
  dubbeleLastenOverbruggingDetails: DubbeleLastenOverbruggingDetails | null;
}): ReactElement => {
  const columns: Column[] = [
    {
      header: "Tijdens overbrugging",
      accessor: () => " ",
    },
    {
      header: "Totale netto maandlasten",
      accessor: "totaleNettoMaandlasten",
      dataType: "currency",
    },
    {
      header: "Nieuwe netto maandlasten",
      accessor: "nieuweNettoMaandlasten",
      dataType: "currency",
    },
    {
      header: "Correctie doorlopende producten",
      accessor: "correctieDoorlopendeProducten",
      dataType: "currency",
    },
    {
      header: "Netto lasten overbrugging",
      accessor: "nettoLastenOverbrugging",
      dataType: "currency",
    },
    {
      header: "Extra maandlasten tijdens overbrugging",
      accessor: "extraMaandlastenTijdensOverbrugging",
      dataType: "currency",
    },
  ];

  return (
    <>
      {dubbeleLastenOverbruggingDetails && (
        <Table
          data={[dubbeleLastenOverbruggingDetails]}
          columns={columns}
          rotate={true}
          id="dubbele-lasten-overbrugging-table"
        />
      )}
    </>
  );
};
